import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { logout } from 'views/Login/Login.actions';
import { sendAsyncRequest } from '../../services/AsyncRequestService';
import Button from "react-bootstrap/Button";
import { Navbar, NavDropdown, Dropdown, Nav } from 'react-bootstrap';
import { getLoggedInUser } from '../../services/AuthService';
import { isLoggedInUserAWUser } from 'services/AWUtilityService';
import { MdAccountCircle, MdMenu } from 'react-icons/md';
import logo from "../../assets/images/RM Logo=Reversed.png";
import { EnvironmentBadge } from '../../components/EnvironmentBadge';
import './Topbar.css';
import colors from 'lookup/Colors';

const topbarStyle = {
  backgroundColor: colors['rm-dark-blue']
};

const navBarLinkStyle = {
  color: colors['rm-gray-light']
};

const Topbar = ({ handleSidebarClick }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const loggedInUser = getLoggedInUser();

  const getLogoutUrlSuccess = () => {
    dispatch(logout(() => {}));
    window.location = '/logout';
  };

  const getLogoutUrlFailure = (error) => {
    console.log("something went wrong", error.data);
  };

  const getLogoutUrl = () => {
    let url = "/auth/logout";
    let method = "GET";
    sendAsyncRequest(url, method, null, getLogoutUrlSuccess, getLogoutUrlFailure);
  };

  const getHeaderButtonText = () => {
    if (location.pathname === '/agent-workspace/list') {
      return 'Agent Dashboard';
    } else {
      return 'Agent Workspace';
    }
  };

  return (
    <Navbar style={topbarStyle} variant="dark">
      <MdMenu className="sidebar-menu-btn" onClick={handleSidebarClick} />
      <Navbar.Brand style={{ padding: "0" }}>
        <img style={{ height: "40px", width: "auto" }} className="logo-large" alt="Imagine RazorMetrics Logo" src={logo} />
      </Navbar.Brand>
      <EnvironmentBadge />
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse className="justify-content-end">
        <Nav>
          {isLoggedInUserAWUser() && (
            <Button
              variant="secondary"
              className="btn-text-white"
              onClick={() =>
                location.pathname === "/agent-workspace/list"
                  ? navigate("/agent-workspace/dashboard")
                  : navigate("/agent-workspace/list")
              }
            >
              {getHeaderButtonText()}
            </Button>
          )}
          <NavDropdown title={loggedInUser ? <span style={navBarLinkStyle}><MdAccountCircle className="account-nav-dropdown" /> {loggedInUser.name}</span> : 'Someone'} className="custom-dd-position">
            <Dropdown.Item onClick={() => navigate("/account/change-password")}>Change Password</Dropdown.Item>
          </NavDropdown>
          <Nav.Link style={navBarLinkStyle} onClick={getLogoutUrl}>
            Logout
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Topbar;
